import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RestService } from '../../../shared/shared.module';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BlogComponent implements OnInit {

  public myTemplate: any = '';
  constructor(private restService: RestService) {
    this.restService.urlGet<string>('/assets/Documents/blog.html', { responseType: 'text' })
      .then(data =>
        this.myTemplate = data
      );
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landing/info/blog/blog.component.ts